import * as React from 'react';
import { ComponentProps, WidgetProps } from '@intermix-dashboard/core';
import 'chartjs-plugin-streaming';
import { useThemeObserver } from '../hooks/useThemeObserver';
const Line = React.lazy(() =>
  import('react-chartjs-2').then((module) => ({ default: module.Line }))
);

export const IntermixStreamingLineChartComponent: React.FC<ComponentProps> = ({
  data,
  options,
}) => {
  const { display } = useThemeObserver();
  return (
    <React.Suspense fallback="loading...">
      {display && <Line data={data} options={options} />}
    </React.Suspense>
  );
};

export const StreamingLineChartWidget: WidgetProps = {
  id: 'line-stream-chart',
  name: 'Streaming Line Chart',
  component: IntermixStreamingLineChartComponent,
  options: { w: 4, h: 4 },
};
